import React, { useState, forwardRef, useEffect, useCallback } from   'react';
import { useNavigate, useParams} from 'react-router-dom';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { useForm, Controller } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { DateTime } from 'luxon';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import { FaCalendar } from 'react-icons/fa';
import { ConsultarPersonaDocumento } from '../../Auth/ConsultasApi';
import PropTypes from 'prop-types';
import moment from 'moment';
registerLocale('es', es);
setDefaultLocale('es');

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' data-tooltip-id='tooltiparriba' data-tooltip-content="Seleccionte fecha" style={{ border: 'none', background: 'transparent', pointerEvents: 'none' }}/>
        <FaCalendar/>
    </button>
));

CustomInput.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
};
export default function CrearRecepcionPersona(){
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const { idRecepcion } = useParams();
    const { sedeActual } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [navigateAfterMessage, setNavigateAfterMessage] = useState(null);
    const [prioridadesAtencion, setPrioridadesAtencion] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [motivo, setMotivo] = useState('');
    const [alberguePersona, setAlberguePersona] = useState([]);
    const { watch, handleSubmit, register, setValue, clearErrors, getValues, reset, control, formState: { errors }} = useForm();
    const { rep_prioridad } = watch();
    const { txtAtencionBloqueada } = watch();
    const { rep_atencionanulada } = watch();
    const onSubmit = async (data) => {
        setCargando(true);
        const url =(data.Id === '0')?'/diagnostico/recepcion/guardarrecepcion':'/diagnostico/recepcion/actualizarrecepcion'
        // Validate filename if file is present
        if (data.act_filename) {
            const nameOnly = data.act_filename.replace(/\.[^/.]+$/, ''); // strip extension
            const validName = /^[A-Za-z0-9]+$/.test(nameOnly);
            if (!validName) {
                setCargando(false);
                setError('act_filename', { 
                    type: 'pattern', 
                    message: 'El nombre del archivo sólo debe contener letras y números, sin espacios ni caracteres especiales' 
                });
                return;
            }
        }
        if (data.act_file instanceof File) {
            const maxSize = 12 * 1024 * 1024;

            if (data.act_file.size > maxSize) {
                setCargando(false);
                Mensaje(
                    'Guardar recepción fallo',
                    JSON.stringify('El archivo no puede superar los 12 MB.')
                );
                return;
            }
        }
        try {
            // if a file was selected, send multipart/form-data
            if (data.act_file instanceof File) {
                const base64String = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(data.act_file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                });
                const payload = {
                    ...data,
                    contentBase64: base64String
                };
                
                const response = await apiService.post(url, payload, token);
                if (response.status === 200) {
                    setNavigateAfterMessage('/dx/recepciondx');
                    if (response.data.file){
                        Mensaje(`Guardar recepción con éxito, ID: ${response.data.file}`);
                    }
                }
            } else {
                // no file — send JSON as before
                const response = await apiService.post(url, data, token);
                if (response.status === 200) {
                    setNavigateAfterMessage('/dx/recepciondx');
                    Mensaje(`Guardar recepción con éxito, ID: ${response.data.id}`);
                }
            }
        } catch (error) {
            if (error.status === 422) {
                Mensaje('Guardar recepción', JSON.stringify(error.response.data.errors));
            } else if (error.status === 409) {
                Mensaje('Guardar recepción', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    async function DescargarArchivo(){
        setCargando(true);
        const filename = getValues('strCedulafile') || '';
        
        try {
            const response = await apiService.getFile('/diagnostico/recepcion/downfilepdf', { filename: filename }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            Mensaje('Descargar archivo', `Hubo un error al descargar el archivo ${filename}: ${err}`);
        } finally {
            setCargando(false);
        }
    }
    
    const VolveraRecepciones = () => {
        navigate('/dx/recepciondx');
    }
    async function AnularDX(){
        const url = '/diagnostico/recepcion/anularrecepcion';
            const obj = {
                usrid : user,
                idRecepcion: idRecepcion,
                motivo: motivo,
            };
            await apiService.post(url, obj, token)
                .then((response) => {
                    if(response.status === 200){
                        Mensaje('Anular Diagnóstico', 'Diagnóstico anulado correctamente');
                        navigate('/dx/recepciondx');
                    }
                })
                .catch((error) => {
                    if(error.status === 422){
                        Mensaje('Anular Diagnóstico', JSON.stringify(error.response.data.errors));
                    }else if(error.status === 409){
                        Mensaje('Anular Diagnóstico', JSON.stringify(error.response.data));
                    }
                    console.error('Error liberando diagnóstico:', error);
                })
                .finally(() => {
                    setCargando(false);
                });
        }
    async function ConsultarDocumento(identificacion){
        await ConsultarPersonaDocumento({obj: {per_idpersona: identificacion}, token: token})
        .then((response) => {
            setAlberguePersona(response.data.alberguepersonas || []);
            if(response.data.personas){
                const persona = response.data.personas[0];
                setValue('rep_primernombre', persona.perNombre1);
                setValue('rep_segundonombre', persona.perNombre2 || "");
                setValue('rep_primerapellido', persona.perApellido1);
                setValue('rep_segundoapellido', persona.perApellido2 || "");
                setValue('perParentesco', persona.perParentesco || "");
                setValue('idCabezaFamilia', persona.idCabezaFamilia || "");
            }else{
                Mensaje('Consulta documento','No se encuentra el documento en caracterización');
                setValue('rep_primernombre', "");
                setValue('rep_segundonombre', "");
                setValue('rep_primerapellido', "");
                setValue('rep_segundoapellido', "");
                setValue('perParentesco', "");
                setValue('idCabezaFamilia', "");
            }
        })
        .catch((error) => { 
            console.error('Error al consultar documento:', error);
        });
        
        
    }

    const InicializarFormulario = useCallback(async () => {
        const fecha = DateTime.now().toISODate();
        const url = '/diagnostico/recepcion/crearformulariorecepcion';
        const obj = { idRecepcion: idRecepcion, sede: sedeActual, fecha: fecha}
        try {
            
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if (Array.isArray(result.prioridadesAtencion)) {
                setPrioridadesAtencion(result.prioridadesAtencion);
            } else {
                console.error('Invalid data for prioridadesAtencion:', result.prioridadesAtencion);
                setPrioridadesAtencion([]);
            }
            if (Array.isArray(result.profesionalessededia)) {
                setProfesionales(result.profesionalessededia);
            } else {
                console.error('Invalid data for profesionalessededia:', result.profesionalessededia);
                setProfesionales([]);
            }
            if (Array.isArray(result.municipios)) {
                setMunicipios(result.municipios);
            } else {
                console.error('Invalid data for municipios:', result.municipios);
                setMunicipios([]);
            }
            if(result.recepcionDeclaraciones){
                reset((prevValues) => ({
                    ...prevValues,
                    Id: idRecepcion,
                    rep_fichodia: result.recepcionDeclaraciones[0].repFichodia,
                    rep_sede: result.recepcionDeclaraciones[0].repSede,
                    rep_fechahorarecepcion: result.recepcionDeclaraciones[0].repFechahorarecepcion,
                    rep_identificacion: result.recepcionDeclaraciones[0].repIdentificacion,
                    rep_primernombre: result.recepcionDeclaraciones[0].repPrimernombre,
                    rep_segundonombre: result.recepcionDeclaraciones[0].repSegundonombre,
                    rep_primerapellido: result.recepcionDeclaraciones[0].repPrimerapellido,
                    rep_segundoapellido: result.recepcionDeclaraciones[0].repSegundoapellido,
                    rep_prioridad: result.recepcionDeclaraciones[0].repPrioridad?.toString() ?? '',
                    rep_profesionalatencion: result.recepcionDeclaraciones[0].repProfesionalatencion,
                    rep_estadoatencion: result.recepcionDeclaraciones[0].repEstadoatencion,
                    rep_gestorrecepcion: result.recepcionDeclaraciones[0].repGestorrecepcion,
                    rep_diagnosticoid: result.recepcionDeclaraciones[0].repDiagnosticoid,
                    rep_atencionanulada: result.recepcionDeclaraciones[0].repAtencionanulada,
                    rep_fechadeclaracion: result.recepcionDeclaraciones[0].repFechadeclaracion,
                    rep_codigofud: result.recepcionDeclaraciones[0].repCodigofud,
                    rep_municipio_desplazamiento: result.recepcionDeclaraciones[0].repMunicipioDesplazamiento
                    ? String(result.recepcionDeclaraciones[0].repMunicipioDesplazamiento)
                    : "",
                    rep_entorno: result.recepcionDeclaraciones[0].repEntorno,
                    rep_obsvivanto: result.recepcionDeclaraciones[0].repObsvivanto,
                    rep_obssigma: result.recepcionDeclaraciones[0].repObssigma,
                    rep_obssisben: result.recepcionDeclaraciones[0].repObssisben,
                    rep_obsfosyga: result.recepcionDeclaraciones[0].repObsfosyga,
                    txtAtencionBloqueada: result.recepcionDeclaraciones[0].txtAtencionBloqueada,
                    strCedulafile: result.recepcionDeclaraciones[0].strCedulafile,
                }));
            }else{
                const fechahoy = new Date()
                fechahoy.setHours(fechahoy.getHours() - 5)
                reset((prevValues) => ({
                    ...prevValues,
                    Id: idRecepcion,
                    rep_fichodia: 0,
                    rep_gestorrecepcion: user,
                    rep_diagnosticoid: 0,
                    rep_atencionanulada: '',
                    rep_fechahorarecepcion: fechahoy,
                    rep_fechadeclaracion: fechahoy,
                    rep_estadoatencion: 1,
                    rep_sede: sedeActual,
                    txtAtencionBloqueada: '',
                }));
            }
            if (result.diagnosticobloqueado?.diaMotivo) {
                setValue('txtAtencionBloqueada', result.diagnosticobloqueado.diaMotivo);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }, [idRecepcion, sedeActual, token, user, reset]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    
    useEffect(() => {
        InicializarFormulario();
    }, [InicializarFormulario]);
    const [showAnularModal, setShowAnularModal] = useState(false);
    const openAnularModal = () => {
        setShowAnularModal(true);
    }
    const closeAnularModal = () => {
        setShowAnularModal(false);
    }
    function LiberarRecepcion(){
        setCargando(true);
        const url = '/diagnostico/recepcion/liberarrecepcion';
        const obj = { idRecepcion: idRecepcion, usrid: user };
        apiService.post(url, obj, token)
            .then((response) => {
                if(response.status === 200){
                    Mensaje('Liberar recepción', 'Recepción liberada correctamente');
                    navigate('/dx/recepciondx');
                }
            })
            .catch((error) => {
                if(error.status === 422){
                    Mensaje('Liberar recepción', JSON.stringify(error.response.data.errors));
                }else if(error.status === 409){
                    Mensaje('Liberar recepción', JSON.stringify(error.response.data));
                }
                console.error('Error liberando recepción:', error);
            })
            .finally(() => {
                setCargando(false);
            });
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Crear recepción DX"
                idCabezaFamilia="1"
                url="/dx/recepciondx"
                nombreurl="Recepción dx"
                nombreform="Crear"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <div className="card card">
                        <div className='card-header'>
                            <h3 className='card-title'><b>Formulario recepci&oacute;n documentos</b><p>Llenar todos los campos para el declarante.</p></h3>
                        </div>
                        {(idRecepcion>0) && <div className="container-fluid">
                            <div className="row justify-content-center">
                            <div className="col-md-12 col-12">
                                <div className="info-box bg-blue">
                                <h3 id="hFichoNumero" style={{fontSize: '70px'}} aria-label="Ficho Numero">Ficho Numero</h3>
                                    <p>Ficho Numero: 1</p>              
                                <p id="personaFichoNumero" />
                                </div>
                            </div>
                            </div>
                        </div>}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <div className="box">
                                    <div className="row">
                                        <input type='hidden' {...register('Id')}/>
                                        <input type='hidden' {...register('rep_gestorrecepcion')}/>
                                        <input type='hidden' {...register('rep_diagnosticoid')}/>
                                        {(idRecepcion > 0) && <div className="col-md-2">
                                            <div className="form-group">
                                            <label htmlFor="rep_fichodia">Ficho</label>
                                            <input readOnly={true} id="rep_fichodia" {...register('rep_fichodia')} type="text" className="form-control" placeholder="Ficho" />   
                                            </div>                
                                        </div>}
                                        {(idRecepcion > 0) && <div id="fechaHoraAtencion" className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='rep_fechahorarecepcion'>Fecha y hora recepci&oacute;n:</label>
                                                <Controller
                                                        control={control}
                                                        name="rep_fechahorarecepcion"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                <DatePicker
                                                                disabled={true}
                                                                id="rep_fechahorarecepcion"
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd hh:mm"
                                                                maxDate={new Date()}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                {errors.rep_fechahorarecepcion && <p style={{color: 'red'}}>Digite fecha recepci&oacute;n</p>}
                                            </div>
                                        </div>}
                                        {alberguePersona.length > 0 && (
                                            <div className="col-md-12">
                                                <div className="alert alert-info" role="alert" style={{marginTop: 10}}>
                                                    <b>Albergue(s) asociados a la persona:</b>
                                                    <ul style={{marginBottom: 0}}>
                                                        {alberguePersona.map((item) => (
                                                            <li key={item.id}>
                                                                Diagnostico realizado el {(moment(item.dx_fecha).isValid())?item.dx_fecha.split('T')[0]:''} por {item.dx_7_1_nombre_responsable_atencion}.
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                        <input type='hidden' {...register('rep_sede')}/>
                                        <input type='hidden' {...register('rep_estadoatencion')}/>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 style={{backgroundColor:'#f7f7f7', fontSize: '18px', textAlign: 'center', padding: '7px 10px', marginTop: '0'}}>
                                            Declarante
                                            </h4>
                                        </div>  
                                    </div>
                                    <div className="row">              
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="rep_identificacion">Identificaci&oacute;n:</label>
                                                <input 
                                                    id="rep_identificacion" 
                                                    {...register('rep_identificacion', { 
                                                        required: "Digite Identificación",
                                                        validate: value => value && value !== "0" ? true : "La identificación no puede ser 0 ni estar vacía"
                                                    })}  
                                                    className="form-control" 
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('rep_identificacion', value); // Update the value in the form
                                                    }}
                                                    onBlur={(e) => {
                                                        ConsultarDocumento(e.target.value);
                                                    }}
                                                    placeholder="Identificación"
                                                />
                                                {errors.rep_identificacion && <p style={{color: 'red'}}>{errors.rep_identificacion.message}</p>}
                                            </div>
                                        </div>
                                        {watch('rep_identificacion') !== '' && (
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <label htmlFor="info_persona">Informaci&oacute;n de la Persona:</label>
                                                    <textarea
                                                        id="info_persona"
                                                        className="form-control"
                                                        style={{
                                                            color: watch('rep_primernombre') ? 'blue' : undefined
                                                        }}
                                                        rows={1}
                                                        readOnly
                                                        value={
                                                            watch('rep_primernombre') || watch('rep_primerapellido')
                                                                ? `Nombre: ${watch('rep_primernombre') || ''} ${watch('rep_segundonombre') || ''} ${watch('rep_primerapellido') || ''} ${watch('rep_segundoapellido') || ''} figura como ${watch('perParentesco') || '' } de ${watch('idCabezaFamilia') || '' } en modulo caracterización.`
                                                                : 'No se encontró información para la identificación  en caracterización.'
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="row"> 
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="rep_primernombre">Primer Nombre:</label>
                                                <input 
                                                    id="rep_primernombre" 
                                                    {...register('rep_primernombre', { required: true })}  
                                                    className="form-control" 
                                                    placeholder="Primer Nombre"
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setValue('rep_primernombre', value);
                                                      }}
                                                />
                                                {errors.rep_primernombre && <p style={{color: 'red'}}>Digite Primer Nombre</p>}
                                            </div>                 
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="rep_segundonombre">Segundo Nombre:</label>
                                                <input {...register('rep_segundonombre')}  
                                                    className="form-control" 
                                                    placeholder="Segundo Nombre"
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setValue('rep_segundonombre', value);
                                                      }}/>
                                                {errors.rep_segundonombre && <p style={{color: 'red'}}>Digite Segundo Nombre</p>}
                                            </div>                 
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="rep_primerapellido">Primer Apellido:</label>
                                                <input id="rep_primerapellido" 
                                                {...register('rep_primerapellido', { required: true })}  
                                                className="form-control" 
                                                placeholder="Primer Apellido"
                                                onChange={(e) => {
                                                    const value = e.target.value.toUpperCase();
                                                    setValue('rep_primerapellido', value);
                                                  }}/>
                                                {errors.rep_primerapellido && <p style={{color: 'red'}}>Digite Primer Apellido</p>}
                                            </div>                 
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="rep_segundoapellido">Segundo Apellido:</label>
                                                <input {...register('rep_segundoapellido')}
                                                    className="form-control" 
                                                    placeholder="Segundo Apellido"
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setValue('rep_segundoapellido', value);
                                                      }}/>
                                                {errors.rep_segundoapellido && <p style={{color: 'red'}}>Digite Segundo Apellido</p>}
                                            </div>                 
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="rep_prioridad">Prioridad atenci&oacute;n:</label>
                                                <select {...register('rep_prioridad')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {prioridadesAtencion.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.id}-{option.priPrioridad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.rep_prioridad && <p style={{color: 'red'}}>Seleccione Prioridad atenci&oacute;n</p>}
                                            </div>  
                                        </div>
                                        {rep_prioridad === '2' && <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="rep_profesionalatencion">Profesional atenci&oacute;n:</label>
                                                <select {...register('rep_profesionalatencion', { validate: value => {
                                                    if (rep_prioridad === '2' && !value) {
                                                    return 'Seleccione profesional atención';
                                                    }
                                                    return true;
                                                }
                                                })} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {profesionales.map((option) => (
                                                    <option key={option.proProfesional} value={option.proProfesional}>
                                                        {option.proNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.rep_profesionalatencion && <p style={{color: 'red'}}>Seleccione Profesional atención</p>}
                                            </div>  
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="act_file">Subir cedula</label>
                                                <input
                                                    type="file"
                                                    accept="application/pdf"
                                                    className="form-control"
                                                    multiple={false}
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0] ?? null;
                                                        // reset previous errors/values
                                                        clearErrors('act_file');
                                                        clearErrors('act_filename');
                                                        if (!f) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            return;
                                                        }
                                                        if (f.type !== 'application/pdf') {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_file', { type: 'type', message: 'Solo se permiten archivos PDF' });
                                                            return;
                                                        }
                                                        // Validate file size (max 12 MB)
                                                        const maxSize = 12 * 1024 * 1024; // 12 MB
                                                        
                                                        // validate filename: only letters and numbers (no special chars, no spaces)
                                                        const nameOnly = f.name.replace(/\.[^/.]+$/, ''); // strip extension
                                                        const validName = /^[A-Za-z0-9]+$/.test(nameOnly);
                                                        if (!validName || f.size > maxSize) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_filename', { type: 'pattern', message: `El nombre del archivo sólo debe contener letras y números, sin espacios ni caracteres especiales y no debe superar los 12 MB` });
                                                            return;
                                                        }

                                                        const reader = new FileReader();
                                                        reader.onload = (ev) => {
                                                            try {
                                                                const dataUrl = ev.target.result || '';
                                                                const base64 = dataUrl.split(',')[1] || '';

                                                                clearErrors('act_file');
                                                                clearErrors('act_filename');
                                                                setValue('act_file', base64, { shouldValidate: true, shouldDirty: true });
                                                                // store only the validated name (keep extension if needed)
                                                                setValue('act_filename', f.name, { shouldValidate: false, shouldDirty: false });
                                                            } catch (err) {
                                                                setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                                setValue('act_filename', '', { shouldValidate: false });
                                                            }
                                                        };
                                                        reader.onerror = () => {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                        };
                                                        reader.readAsDataURL(f);
                                                    }}
                                                    aria-label="Seleccionar archivo (PDF)"
                                                />
                                                <input type='hidden' {...register('act_file')} />
                                                <input type='hidden' {...register('act_filename')} />
                                                {errors.act_file && <p style={{ color: 'red' }}>{errors.act_file.message || 'Ingrese archivo'}</p>}
                                                {errors.act_filename && <p style={{ color: 'red' }}>{errors.act_filename.message || 'Nombre de archivo inválido'}</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Cedula actual</label>
                                                {watch('strCedulafile') ? (
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            onClick={async () => {
                                                                await DescargarArchivo();
                                                            }}
                                                            aria-label={`Ver archivo ${watch('strCedulafile')}`}
                                                        >
                                                            {watch('strCedulafile')}
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <p className="form-control-plaintext">Sin archivo</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {txtAtencionBloqueada !== "" && <div className="col-md-12">
                                            <div className="col-md-12">
                                                <label htmlFor="txtAtencionBloqueada">Atencion bloqueada
                                                </label>
                                                <textarea disabled rows={3} style={{ width: '100%' }}
                                                    {...register('txtAtencionBloqueada')}
                                                    placeholder="Atencion bloqueada"
                                                />
                                                {errors.txtAtencionBloqueada && <p style={{color: 'red'}}>Atencion bloqueada</p>}
                                            </div>
                                        </div>}
                                        {rep_atencionanulada !== "" && <div className="col-md-12">
                                            <div className="col-md-12">
                                                <label htmlFor='rep_atencionanulada' hidden>Atencion bloqueada</label>
                                                <textarea id='rep_atencionanulada' disabled rows={3} style={{ width: '100%' }}
                                                    {...register('rep_atencionanulada')}
                                                    placeholder="Atencion anulada"
                                                />
                                                {errors.rep_atencionanulada && <p style={{color: 'red'}}>Atencion anulada</p>}
                                            </div>
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 style={{backgroundColor:'#f7f7f7', fontSize: '18px', textAlign: 'center', padding: '7px 10px', marginTop: '0'}}>
                                            Declaraci&oacute;n
                                            </h4>  
                                        </div>              
                                    </div>
                                    <div className="row">
                                        <div id="fechaDeclaracion" className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='rep_fechadeclaracion'>Fecha declaraci&oacute;n:
                                                    <Controller
                                                        id="rep_fechadeclaracion"
                                                        control={control}
                                                        name="rep_fechadeclaracion"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                <DatePicker
                                                                placeholderText="fecha declaración"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.rep_fechadeclaracion && <p style={{color: 'red'}}>Digite Fecha declaraci&oacute;n</p>}
                                                </label>
                                            </div>             
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="rep_codigofud">Código FUD (VIVANTO)):</label>
                                                <input id="rep_codigofud" 
                                                    {...register('rep_codigofud', { required: true })}  className="form-control" placeholder="Código FUD"
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Sino sabe el codigo FUD, escribir Sin dato"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
                                                        setValue('rep_codigofud', value);
                                                      }}/>
                                                {errors.rep_codigofud && <p style={{color: 'red'}}>Debe digitar codigo FUD</p>}
                                            </div>  
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='rep_municipio_desplazamiento'>Lugar del hecho (municipio):</label>
                                                {municipios.length === 0 ? (
                                                    <div>Cargando municipios...</div>
                                                ) : (
                                                    <select
                                                        id='rep_municipio_desplazamiento'
                                                        {...register('rep_municipio_desplazamiento', { required: true })}
                                                        className='form-control'
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {municipios.map((option) => (
                                                            <option key={option.id} value={String(option.id)}>
                                                                {option.munMunicipio}-{option.munDepartamento}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                {errors.rep_municipio_desplazamiento && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                            </div>
                                        </div>              
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="rep_entorno">Entorno:</label>
                                                <input id="rep_entorno" {...register('rep_entorno', { required: true })}  className="form-control" placeholder="Entorno"
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Colocar el nombre del barrio, vereda o corregimiento."
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        setValue('rep_entorno', value);
                                                      }}/>
                                                {errors.rep_entorno && <p style={{color: 'red'}}>Digite Entorno</p>}
                                            </div>               
                                        </div>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="box box-default">
                                                <div className="box-header with-border">
                                                    <h3 className="box-title">Observación consulta a base de datos VIVANTO, SISBEN y ADRES.</h3>
                                                </div>
                                                {/* /.box-header */}
                                                <div className="box-body" style={{display: 'block'}}>
                                                    <div className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="rep_obsvivanto">Observaciones VIVANTO</label>
                                                            <textarea 
                                                                id="rep_obsvivanto" 
                                                                rows={3} 
                                                                style={{ width: '100%' }}
                                                                {...register('rep_obsvivanto')}
                                                                placeholder="Observaciones VIVANTO"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.toUpperCase();
                                                                    setValue('rep_obsvivanto', value);
                                                                  }}
                                                            />
                                                            {errors.rep_obsvivanto && <p style={{color: 'red'}}>Favor Observaciones VIVANTO</p>}
                                                        
                                                    </div> 
                                                    <div hidden className="col-md-12">
                                                        <label htmlFor="rep_obssigma">Observaciones SIGMA</label>
                                                            <textarea rows={3} style={{ width: '100%' }}
                                                                {...register('rep_obssigma')}
                                                                placeholder="Observaciones SIGMA"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.toUpperCase();
                                                                    setValue('rep_obssigma', value);
                                                                  }}
                                                            />
                                                            {errors.rep_obssigma && <p style={{color: 'red'}}>Favor Observaciones SIGMA</p>}
                                                        
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="rep_obssisben">Observaciones SISBEN</label>
                                                            <textarea rows={3} style={{ width: '100%' }}
                                                                {...register('rep_obssisben')}
                                                                placeholder="Observaciones SISBEN"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.toUpperCase();
                                                                    setValue('rep_obssisben', value);
                                                                  }}
                                                            />
                                                            {errors.rep_obssisben && <p style={{color: 'red'}}>Favor Observaciones SISBEN</p>}
                                                        
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="rep_obsfosyga">Observaciones ADRES</label>
                                                            <textarea id="rep_obsfosyga" rows={3} style={{ width: '100%' }}
                                                                {...register('rep_obsfosyga')}
                                                                placeholder="Observaciones ADRES"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.toUpperCase();
                                                                    setValue('rep_obsfosyga', value);
                                                                  }}
                                                            />
                                                            {errors.rep_obsfosyga && <p style={{color: 'red'}}>Favor Observaciones ADRES</p>}
                                                        
                                                    </div>
                                                    </div>
                                                </div>
                                                {/* /.box-body */}
                                            </div>
                                            {/* /.box */}
                                        </div>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="btn-group">
                                                <button type="submit" className="btn btn-primary btn-sm" id="btnRecepcionGuardar" style={{ marginRight: '10px' }}>Guardar</button>
                                                {idRecepcion > 0 && watch('rep_estadoatencion') === 5 && <button type="button" className="btn btn-primary btn-sm" id="btnRecepcionReasignar" onClick={LiberarRecepcion} style={{ marginRight: '10px' }}>Liberar</button>}
                                                {idRecepcion > 0 && (watch('rep_estadoatencion') === 5 || watch('rep_estadoatencion') === 1) && <button
                                                    id="btnModalLiberalDX"
                                                    type="button"
                                                    className="btn btn-primary"
                                                    style={{ backgroundColor: 'red', marginRight: '10px' }}
                                                    onClick={openAnularModal}
                                                >
                                                    Anular
                                                </button>}
                                                <button type="button" className="btn btn-primary btn-sm" id="btnCancelarRecepcion" onClick={VolveraRecepciones} style={{ marginRight: '10px' }}>Cancelar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </form>
                    </div>

                    {showAnularModal && (
                        <div className="modal fade show" style={{display: 'block'}} tabIndex="-1" aria-labelledby="modalAnularDXLabel" aria-modal="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="modalAnularDXLabel">Anular</h5>
                                        <button type="button" className="close" aria-label="Cerrar" onClick={closeAnularModal}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label htmlFor="motivoAnularDX">Motivo de la Anulacion</label>
                                            <textarea
                                                id="motivoAnularDX"
                                                className="form-control"
                                                rows="3"
                                                maxLength="500"
                                                placeholder="Ingrese el motivo de la anulacion"
                                                value={motivo}
                                                onChange={e => setMotivo(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <p>¿Est&aacute; seguro que desea anular este diagn&oacute;stico?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={closeAnularModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={() => { closeAnularModal(); AnularDX(); }}>
                                            Anular
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    const pendingNavigate = navigateAfterMessage;
                    setSwalProps({})
                    setNavigateAfterMessage(null);
                    if (pendingNavigate) {
                        navigate(pendingNavigate);
                    }
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}